import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';

const LINEUP_IMAGE = "/images/artwork/lineup-cover.jpg";

// Exact lineup from user
const ariaStage = {
  name: 'Aria Stage',
  genre: 'Melodic Techno & Hard Dance',
  headliners: '8Kays • Agents of Time • Ammara • Bradeazy • Eelke Kleijn • Henri Bergmann • Innellea • Monkey Safari • Øostil • Pacs • Part Time Killer • Serafina • Silver Panda • Stephan Bodzin (live) • Zwilling',
  subheadliners: 'Kiara Friend • Liia • Lola Voss • Mad.Day • Shani • Staffy',
  support: 'Anton Yaz • Artisah • Caike • Daniel Tonik • Elle Cooper • Emma Bass • Jakob • Lady Blu • Lily Ro • Moritzio • Nadine B • Nick Reverse'
};

const mandalaStage = {
  name: 'Mandala Stage',
  genre: 'Psy-Tech & Progressive Psytrance',
  headliners: 'Astrix • Berg • Dang3r • Ghostrider • Interactive Noise • Liquid Soul • Morten Granau • Ranji • Ritmo • Shanti People • Sighter',
  subheadliners: 'Farseer • Grouch • Kyoshi • Ryanosaurus • Sammy La Marca • ShadowFX • Soul Alignment • Tetrameth • Triforce • Twisted Siblings',
  support: 'Ajem • Ben Zen • Blaize Bass • Boom Shankar • Carlos • Daas • Doof Nights • Eliad • Ishan • KnowHow • Party Explorers • Psychephilia'
};

function StageCard({ stage, bgColor }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className={`${bgColor} rounded-3xl p-8 sm:p-10`}
    >
      <h3 className="font-supertaste text-3xl sm:text-4xl text-ff-brown mb-2">{stage.name}</h3>
      <p className="text-ff-brown/60 mb-8 font-semibold uppercase tracking-wide text-sm">{stage.genre}</p>
      
      <div className="space-y-6">
        <div>
          <p className="text-ff-outline text-xs font-bold uppercase tracking-wider mb-3">Headliners</p>
          <p className="text-ff-brown text-lg font-medium leading-relaxed">{stage.headliners}</p>
        </div>
        <div>
          <p className="text-ff-outline text-xs font-bold uppercase tracking-wider mb-3">Sub-headliners</p>
          <p className="text-ff-brown/80 leading-relaxed">{stage.subheadliners}</p>
        </div>
        <div>
          <p className="text-ff-outline text-xs font-bold uppercase tracking-wider mb-3">Support</p>
          <p className="text-ff-brown/60 text-sm leading-relaxed">{stage.support}</p>
        </div>
      </div>
    </motion.div>
  );
}

export default function Lineup() {
  return (
    <div className="min-h-screen bg-ff-blue" data-testid="lineup-page">
      <SEO 
        title="Lineup"
        description="Frequency Forest 2026 lineup: Stephan Bodzin, Astrix, Innellea, Liquid Soul, Agents of Time & 60+ artists across Aria Stage (Melodic Techno) and Mandala Stage (Psytrance)."
        image="/images/artwork/lineup-cover.jpg"
      />
      {/* Hero with lineup poster */}
      <section className="relative h-[60vh] sm:h-[70vh] min-h-[500px]">
        <img
          src={LINEUP_IMAGE}
          alt="Frequency Forest Lineup"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ff-blue via-ff-blue/30 to-transparent" />
      </section>

      {/* Lineup Content */}
      <section className="py-16 sm:py-24 px-6">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="badge">25–27 SEP 2026</span>
              <span className="badge">Maitland Showgrounds</span>
            </div>
            <h1 className="font-display text-5xl sm:text-6xl md:text-7xl text-ff-brown mb-4">Lineup</h1>
            <p className="text-ff-brown/60">Two stages. Three days. Listed A–Z within tier.</p>
          </motion.div>

          {/* Stage Cards */}
          <div className="space-y-8">
            <StageCard stage={ariaStage} bgColor="bg-ff-pink" />
            <StageCard stage={mandalaStage} bgColor="bg-ff-orange" />
          </div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-center mt-16"
          >
            <p className="text-ff-brown/40 text-sm mb-6">More artists to be announced</p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
